module.exports = __webpack_public_path__ + "img/BlinkArt_Sword10_Dark.d6d87530.png";